module.exports = __webpack_public_path__ + "static/media/docker.3d0bf3c1.svg";